import SectionHeading from "./SectionHeading";
import { criteria } from "@/mocks/columns";

const scale = [
  { low: "0–40%", label: "明显失实", tone: "bg-foreground-800 text-background-50" },
  { low: "40–60%", label: "证据不足 · 存疑", tone: "bg-secondary-500 text-background-50" },
  { low: "60–80%", label: "部分属实", tone: "bg-accent-500 text-primary-950" },
  { low: "80–100%", label: "结论可信", tone: "bg-primary-500 text-background-50" },
];

export default function CriteriaSection() {
  return (
    <section id="criteria" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          <div>
            <SectionHeading
              align="left"
              eyebrow="鉴定标准"
              title="可信度评分怎么来的"
              desc="我们不用拍脑袋的「真假」，而是给每条在线黑料一个透明、可解释的可信度区间，让读者知道结论依据什么而来。"
            />
            <ul className="space-y-4">
              {criteria.map((c) => (
                <li
                  key={c.title}
                  className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center shrink-0 font-heading font-bold">
                    {c.weight.replace("权重 ", "")}
                  </span>
                  <div>
                    <div className="flex items-center gap-3">
                      <h3 className="font-heading text-base font-bold text-foreground-950">
                        {c.title}
                      </h3>
                      <span className="text-xs font-medium text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
                        {c.weight}
                      </span>
                    </div>
                    <p className="mt-1 text-sm text-foreground-700 leading-relaxed">{c.note}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:sticky lg:top-24">
            <div className="rounded-lg bg-background-50 border border-background-200 p-6 md:p-8">
              <div className="flex items-center gap-2 text-primary-700 font-semibold text-sm">
                <i className="ri-scales-3-line"></i>
                结论分级色卡
              </div>
              <h3 className="mt-2 font-heading text-xl font-bold text-foreground-950">
                一图读懂判断口径
              </h3>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                每条公开结论都会落在四个区间之一，并附评分与存疑说明，读者可据此决定是否采信或转发。
              </p>

              <ul className="mt-6 space-y-3">
                {scale.map((s) => (
                  <li
                    key={s.low}
                    className="flex items-center gap-4 rounded-md border border-background-200 bg-background-100/70 p-3.5"
                  >
                    <span
                      className={`w-24 shrink-0 text-center px-2 py-1.5 rounded-md text-xs font-bold ${s.tone}`}
                    >
                      {s.low}
                    </span>
                    <span className="text-sm font-medium text-foreground-800">{s.label}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 rounded-md bg-accent-100 border border-accent-200 p-4">
                <p className="text-sm leading-relaxed text-accent-900">
                  <i className="ri-question-line mr-1"></i>
                  评分会随新证据出现而变化。若当事方补充一手资料，我们会重新核对并更新旧结论。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}